<template>
  <div class="expert-block">
    <span class="author">Автор материала:</span>
    <nuxt-link to="/expert">
      <div class="expert-wrapper">
        <img src="~/assets/img/ss-logo.png" width="64" alt="expert phto" class="expert-block__logo">
        <p class="expert-block__content">
          <span class="expert-block__content__name">
            Стрункин Роман Витальевич
          </span>
          <span class="expert-block__content__role">
            Эксперт по юридическим вопросам
          </span>
        </p>
      </div>
    </nuxt-link>
  </div>
</template>

<script>
export default {
  name: 'ExpertBlock'
}
</script>

<style lang="scss" scoped>
.expert-block {
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  box-shadow: 0px 7px 17px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  margin-bottom: 23px;
  padding: 20px;
  .author{
    font-size: 14px;
    line-height: 150%;
    color: rgba(62, 62, 62, 0.71);
    text-decoration: none !important;
    margin-bottom:12px;
    &:hover{
      text-decoration: none !important;
    }
  }
.expert-wrapper{
  display: flex;
  align-items: center;
  gap: 16px;
}

  &__logo {
    width: 64px;
    height: 64px;
    border-radius: 32px;
  }
  a{
    &:hover{
      text-decoration: none !important;
    }
  }

  &__content {
    display: block;
    margin: 0;

    &__name {
      display: block;
      font-size: 16px;
      line-height: 150%;
      color: #3E3E3E;
      font-family: var(--font-base);
      font-weight: 600;
    }

    &__role {
      display: block;
      font-size: 16px;
      line-height: 129%;
      color: #3E3E3E;

      // @media (max-width: 767px) {
      //   font-size: 16px;
      //   line-height: 20px;
      // }

      // @media (max-width: 424px) {
      //   font-size: 14px;
      //   line-height: 16px;
      // }
    }
  }
}
</style>
